import { useQuery } from "@tanstack/react-query";
import { orgHierarchyService } from "@/services/orgHierarchyService";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Weekly update status + DRI/IC ownership for the current user's team.
 *
 * Deliberately a separate query from MyTeam's `team-priorities`: that one is bound to the page's
 * status filter chips and capped at 100 rows, so reusing it would make the ownership lists silently
 * change and truncate as the user toggles filters.
 */
export function useTeamUpdateStatus() {
  const { user } = useAuth();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["team-update-status"],
    queryFn: () => orgHierarchyService.getTeamUpdateStatus(),
    enabled: !!user?.pid,
  });

  return {
    weekNumber: data?.weekNumber,
    weekYear: data?.weekYear,
    members: data?.members ?? [],
    isLoading,
    isError,
  };
}
